import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-168">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-cream-dark rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-170">
          <div className="absolute top-0 right-0 w-64 h-64 bg-pink-light rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3" data-id="element-171"></div>

          <div className="relative z-10" data-id="element-172">
            <div className="flex items-center gap-3 mb-6 text-pink" data-id="element-173">
              <AlertCircle size={32} data-id="element-174" />
              <h2 className="text-3xl md:text-4xl font-bold text-slate" data-id="element-175">
                La cruda realidad
              </h2>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-slate-light leading-relaxed" data-id="element-176">
              <p data-id="element-177">
                La mayoría de los métodos de entrenamiento para el baño son una
                tortura. Te dicen que dejes a tu hijo mojado para que "aprenda",
                o que pases semanas atrapada en casa esperando un milagro.
              </p>
              <p className="font-medium text-slate" data-id="element-178">
                El resultado es siempre el mismo: tú terminas frustrada, tu hijo
                termina llorando y tu casa termina oliendo a orina.
              </p>
              <p data-id="element-179">
                Esto sucede porque esos métodos ignoran cómo funciona realmente
                el cerebro y la vejiga de un niño pequeño.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}